import { render, staticRenderFns } from "./detail_dzpz.vue?vue&type=template&id=19ff590c&scoped=true"
import script from "./detail_dzpz.vue?vue&type=script&lang=js"
export * from "./detail_dzpz.vue?vue&type=script&lang=js"
import style0 from "./detail_dzpz.vue?vue&type=style&index=0&id=19ff590c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff590c",
  null
  
)

export default component.exports